import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useContext, useEffect, useRef } from "react";
import { smetaModals, SmetaModalsIdContext } from "../Tools/modalManager";
import { Button as DlgButton, DlgType } from "../Tools/ProjectX";
import { buttonConfig, icons } from "./MessageBoxConsts";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function MessageBox(props: {
  DlgType: DlgType;
  Message: string;
  Buttons?: string | number;
  onSelect?: (
    ev: React.MouseEvent<HTMLButtonElement>,
    requestId?: number | string,
    setReturnValue?: any,
    from?: any,
  ) => Promise<void> | void;
  RequestID?: number | string;
  setReturnValue?: any;
  from?: any;
}) {
  const buttonBlockRef = useRef<HTMLDivElement>(null!);
  const smetaModalId = useContext(SmetaModalsIdContext);

  useEffect(() => {
    if (buttonBlockRef.current) {
      const firstButton = buttonBlockRef.current.querySelector("button");
      if (firstButton) firstButton.focus();
    }
  }, []);

  function handleClickButton(ev: React.MouseEvent<HTMLButtonElement>) {
    smetaModals.close(smetaModalId);
    props.onSelect?.(ev, props.RequestID, props.setReturnValue, props.from);
  }

  const buttons: React.ReactNode[] = [];
  const buttonFlags = props.Buttons ? Number(props.Buttons) : DlgButton.Ok;
  buttonConfig.forEach(({ condition, label, value }) => {
    if (buttonFlags & condition) {
      buttons.push(
        <Button
          size="small"
          style={{ textTransform: "none" }}
          variant="outlined"
          className="button_message"
          value={value}
          data-requestid={props.RequestID}
          onClick={handleClickButton}
        >
          {label}
        </Button>,
      );
    }
  });

  return (
    <>
      <Box style={{ width: "100%", display: "flex" }}>
        <Box style={{ width: "48px", display: "flex", alignItems: "flex-start" }}>{icons[props.DlgType]}</Box>
        <Box
          style={{
            width: "calc(100% - 48px)",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            whiteSpace: "break-spaces",
          }}
        >
          {" "}
          {props.Message}
        </Box>
      </Box>
      <Box style={{ display: "flex", justifyContent: "center" }} ref={buttonBlockRef} tabIndex={-1}>
        {buttons.map((btn, index) => {
          return (
            <Box key={`message-box-btn_${index}`} style={{ width: "max-content", padding: "5px" }}>
              {btn}
            </Box>
          );
        })}
      </Box>
    </>
  );
}
